
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"76","height":"76","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".1","fill":"#8F7A61"}},[_c('path',{attrs:{"d":"M73.288 0H43.429c-.72 0-1.41.286-1.92.795L.797 41.51a2.715 2.715 0 000 3.838l29.857 29.857a2.715 2.715 0 003.838 0L75.206 34.49c.509-.509.795-1.2.795-1.92V2.715c0-1.5-1.215-2.715-2.713-2.715zm-2.715 31.447l-38 38.002-26.02-26.02 38-38h26.02v26.018z"}}),_c('path',{attrs:{"d":"M57.001 27.144A8.142 8.142 0 0065.144 19a8.142 8.142 0 00-8.143-8.143A8.142 8.142 0 0048.858 19a8.142 8.142 0 008.143 8.143zm0-10.858a2.714 2.714 0 11.001 5.429 2.714 2.714 0 010-5.429z"}})])])
          )
        }
      }
    